import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

const field = "w-full bg-[var(--nl-bg-3)] border border-white/10 px-4 py-3.5 text-white font-body placeholder:text-[var(--nl-muted)] focus:outline-none focus:border-gold focus:ring-1 focus:ring-[var(--nl-gold)] transition-colors duration-300";

const empty = { name: "", email: "", phone: "", message: "" };

export const QuoteForm = () => {
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/quotes", form);
      toast.success("Enquiry sent", { description: "We'll get back to you shortly." });
      setForm(empty);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not send. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border border-white/10 bg-[var(--nl-bg-3)] p-8 mt-8" data-testid="quote-panel">
      <p className="label text-gold mb-2">No trip details yet?</p>
      <h3 className="font-serif font-light text-3xl mb-6">Request a quote</h3>
      <form onSubmit={submit} className="space-y-4" data-testid="quote-form">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <input required value={form.name} onChange={set("name")} className={field} placeholder="Name" data-testid="quote-name" />
          <input required value={form.phone} onChange={set("phone")} className={field} placeholder="Phone" data-testid="quote-phone" />
        </div>
        <input required type="email" value={form.email} onChange={set("email")} className={field} placeholder="Email" data-testid="quote-email" />
        <textarea required value={form.message} onChange={set("message")} rows={3} className={field} placeholder="Tell us what you need — event, dates, guests…" data-testid="quote-message" />
        <button
          type="submit"
          disabled={loading}
          className="w-full label border border-white/20 text-white py-3.5 hover:border-gold hover:text-gold transition-colors duration-300 disabled:opacity-60"
          data-testid="quote-submit-button"
        >
          {loading ? "Sending…" : "Send Enquiry"}
        </button>
      </form>
    </div>
  );
};
